export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9246.90a46eea.jpg";